import { createWebHistory, createRouter } from 'vue-router'
import { useDefaultStore } from './store'
import { loadDivisions } from './services/divisions'
import User from '@/services/user'

// Import views
import Cams from '@/views/Cams.vue'
import CamList from '@/views/Cams/CamList.vue'
import CamView from '@/views/Cams/CamView.vue'
import CamArchive from '@/views/Cams/CamArchive.vue'
import Favorite from '@/views/Cams/Favorite.vue'
import CamArchiveNew from '@/views/Cams/CamArchiveNew.vue'
import CamListNew from '@/views/Cams/CamListNew.vue'
import CamViewNew from '@/views/Cams/CamViewNew.vue'
import TimelineNew from '@/components/cam/TimelineNew.vue'
import Auth from '@/views/Auth.vue'
import Login from '@/views/Auth/Login.vue'
import Admin from '@/views/Admin.vue'
import Editor from '@/views/Admin/Editor.vue'
import Error404 from '@/views/Error404.vue'
import ServerStatusPage from '@/views/Admin/ServerStatusPage.vue'
import ConfigBackupsPage from '@/views/Admin/ConfigBackupsPage.vue'
import TimelineStatusPage from '@/views/Admin/TimelineStatusPage.vue'
import AliveStatusPage from '@/views/Admin/AliveStatusPage.vue'
import DivisionsPage from '@/views/Admin/DivisionsPage.vue'
import ArchivePlayer from '@/new/components/ArchivePlayer'
import EditorNew from '@/new/components/Editor'
import IntercomViewNew from '@/views/Cams/IntercomViewNew.vue'
const routes = [
  {
    path: '/',
    component: Cams,
    children: [
      { path: 'testplayer', name: 'player-test', component: TimelineNew },
      { path: 'cam-list/:division?', name: 'cam-list', component: CamList },
      { path: 'cam-listNew/:division?', name: 'cam-listNew', component: CamListNew },
      { path: 'cam/:cam?/:division?', name: 'cam', component: CamView },
      { path: 'cam-new/:cam?/:division?', name: 'cam-new', component: CamViewNew },
      { path: 'cam-archive/:cam?/:division?', name: 'cam-archive', component: CamArchive },
      { path: 'cam-archive-new/:cam?/:division?', name: 'cam-archive-new', component: CamArchiveNew },
      { path: 'cam-archive-better/:cam?/:division?', name: 'cam-archive-better', component: ArchivePlayer },
      { path: 'cam-archive-all/:division?/:all', name: 'cam-archive-all-cams', component: CamArchive },
      { path: 'intercom-new/:intercom?/:division?', name: 'intercom-new', component: IntercomViewNew },
      { path: 'favorite', name: 'cam-favorites', component: Favorite },
    ].map(route => ({ ...route, meta: { transition: 'fade-in-down' } }))
  },
  {
    path: '/auth',
    component: Auth,
    children: [
      { path: 'login', name: 'login', component: Login, meta: { transition: 'fade-in-down' } }
    ]
  },
  {
    path: '/admin',
    component: Admin,
    children: [
      { path: 'alive-status', name: 'alive-status', component: AliveStatusPage, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'server-info', name: 'server-info', component: ServerStatusPage, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'config-backups', name: 'config-backups', component: ConfigBackupsPage, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'timeline-status', name: 'timeline-status', component: TimelineStatusPage, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'divisions', name: 'admin-divisions', component: DivisionsPage, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'editor', name: 'editor', component: Editor, meta: { transition: 'fade-in-down', admin: true } },
      { path: 'editor-new', name: 'editor-new', component: EditorNew, meta: { transition: 'fade-in-down', admin: true } }
    ]
  },
  { path: '/404', name: '404', component: Error404 },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => console.error(err))
}

const handleExternalAuth = async (query) => {
  if (query.token) {
    if (localStorage.token && localStorage.token !== "") return true;
    localStorage.setItem('token', query.token);
    await User.getCurrentUser();
    await loadDivisions();
    return true;
  }
  return false;
}

router.beforeEach(async (to, from, next) => {
  const store = useDefaultStore()
  const { name, params, query } = to
  if (await handleExternalAuth(query)) return next({'name': 'cam-listNew'});
  if (['cam-list', 'cam', 'cam-archive', 'cam-archive-new'].includes(name) && params.division) {
    store.currentDivision = store.allDivisions.find(el => el.guid === params.division)
  }
  
  if (name === 'cam-list' && !params.division) {
    const division = store.allDivisions.sort((a, b) => a.name.localeCompare(b.name))[0]
    if (division) {
      store.currentDivision = division
      return next({ name: 'cam-list', params: { division: division.guid } })
    }
  }
  if (name !== 'login' && !localStorage.token) return next({ name: 'login' })
  if (to.matched.some(route => route.meta.admin)) {
    const currentUser = store.currentUser || await User.getCurrentUser()
    if (!currentUser || currentUser.role !== 1) {
      return next({ name: 'cam-listNew' })
    }
  }
  next()
})
